import { useTranslate } from '@refinedev/core';
import { Tag } from 'antd';
import type { EntitlementProjectionFailure } from '@/api/generated/schemas';

interface ProjectionFailureTagProps {
  value?: EntitlementProjectionFailure | null;
}

export const ProjectionFailureTag = ({ value }: ProjectionFailureTagProps) => {
  const t = useTranslate();
  if (!value) return <>-</>;
  return (
    <Tag color="warning">
      {t(`monetization.revenuecat_billing_periods.projection_failure.${value}`)}
    </Tag>
  );
};
